<template>
  <div class="deviceBind">
    <div style="margin-top: 35px">
      <div v-if="isType === 'detail'" style="height: 30px"></div>
      <el-form ref="deviceBindForm" :rules="rules" :inline="true" :model="deviceBindInfo" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="deviceBindInfo.projectName" style="width: 300px" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目编号" prop="projectId">
              <el-input v-model="deviceBindInfo.projectId" style="width: 300px" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="并网点" prop="gridId">
              <el-select v-model="deviceBindInfo.gridId" style="width: 300px" disabled>
                <el-option v-for="(item,index) in gridOptions" :key="index" :value="item.id"
                  :label="item.gridName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="设备类型" prop="equipTypeName">
              <el-input v-model="deviceBindInfo.equipTypeName" style="width: 300px" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备数量" prop="equipQuantity">
              <el-input v-model="deviceBindInfo.equipQuantity" style="width: 300px" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模版设备" prop="templateEquipDesc">
              <SelectTree v-model="deviceBindInfo.templateEquipDesc" :props="templateTreeProps" nodeKey="equipId"
                :data="templateDeviceTree" :clearable="false" :disabled="isType === 'detail'" style="width: 300px">
              </SelectTree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="11">
          <el-card shadow="never">
            <div slot="header">适配设备列表</div>
            <el-table :data="deviceBindInfo.equipFits" ref="adaptedDeviceTable" height="380" tooltip-effect="dark"
              style="margin: 0 10px">
              <el-table-column prop="emsName" label="网关名称" width="240"></el-table-column>
              <el-table-column prop="emsDesc" label="网关描述" width="140"></el-table-column>
              <el-table-column prop="equipFields" label="通道及设备名称" width="140"></el-table-column>
              <el-table-column prop="equipDesc" label="设备描述" width="140"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="13">
          <el-card shadow="never">
            <div slot="header">参数绑定</div>
            <el-table :data="deviceBindInfo.equipFitBinds" ref="typicalParamTable" height="380" tooltip-effect="dark"
              style="margin: 0 10px">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="equipTyPaName" label="典型数据点" width="200"></el-table-column>
              <el-table-column prop="equipTyPaDesc" label="典型数据点描述" width="200"></el-table-column>
              <template v-if="this.isType === 'detail'">
                <el-table-column prop="fieldsAndDesc" label="项目内数据点及数据点描述" width="300"></el-table-column>
              </template>
              <template v-else>
                <el-table-column prop="fieldsAndDesc" label="项目内数据点及数据点描述" width="300">
                  <template slot-scope="scope">
                    <span class="device-points" @click="setDevicePoints(scope.row)">
                      {{scope.row.fieldsAndDesc || '-'}}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="tools" v-show="isType !== 'detail'">
      <el-button type="primary" @click="onSaveBindBaseInfo">保存</el-button>
      <el-button type="primary" @click="autoMatchDataPoints">自动配置</el-button>
      <el-button type="primary" @click="takeEffectEquipConfig">配置生效</el-button>
      <el-button type="primary" @click="cancel">返回</el-button>
    </div>
    <!-- 项目内数据点及数据点描述配置 -->
    <Dialog ref="dataPointConfigDlg" :title="'数据点配置'" class="device-bind-dlg" :closeOnClickModal="false">
      <div class="config-div">
        <div class="tree-wrap">
          <el-tree ref="pointTree" class="filter-tree" :data="treeDataConfig" highlight-current node-key="id"
            :props="defaultProps" @node-click="handleNodeClick" :default-checked-keys="defaultChecked"
            :default-expand-all="true">
          </el-tree>
        </div>
        <div class="points-wrap">
          <el-table :data="pointTableData" style="width: 100%; overflow-y: auto" stripe @row-click="singleElection"
            :data-size="pointTableData.length" highlight-current-row height="49vh" v-loading="loading">
            <el-table-column align="center" width="40">
              <template slot-scope="scope">
                <el-radio class="radio" v-model="pointSelectionId" :label="scope.row.fieldId">&nbsp;&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column align="center" type="index" width="50" label="序号"></el-table-column>
            <el-table-column align="center" prop="field" label="点位名称"> </el-table-column>
            <el-table-column align="center" prop="fieldDesc" label="点位描述" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="authorization" label="权限" width="80">
              <template slot-scope="{row}">
                <span>{{row.authorization===0?'读':row.authorization===1?'写':'读写'}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="btn-tools">
        <el-button class="btn" type="primary" @click="onSave">保存</el-button>
        <el-button class="btn" type="primary" @click="close">返回</el-button>
      </div>
    </Dialog>
    <Dialog ref="saveErrorDlg" title="错误提示" class="save-error-dlg">
      <el-form :model="errorInfo" label-width="100px">
        <el-form-item label="项目名称:" prop="emsName">
          <el-input v-model="deviceBindInfo.projectName" placeholder="项目名称" style="width: 40%;" disabled></el-input>
        </el-form-item>
        <el-form-item label="设备类型:" prop="sn">
          <el-input v-model="deviceBindInfo.equipTypeName" placeholder="设备类型" style="width: 40%;" disabled></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="errorInfo" height="300" tooltip-effect="dark" style="margin: 0 10px">
        <el-table-column prop="snAndDesc" label="网关"></el-table-column>
        <el-table-column prop="equipDesc" label="设备描述"></el-table-column>
        <el-table-column prop="fields" label="数据点名"></el-table-column>
        <el-table-column prop="errorMsg" label="错误信息"></el-table-column>
      </el-table>

      <div class="tools">
        <el-button type="primary" @click="closeErrorDlg()">关闭</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
  import PROJECTAPI from '@/api/project';
  import EQUIPMENTCONFIGAPI from '@/api/equipmentConfig';
  import TYPICALPARAMAPI from '@/api/typicalParam';
  import Dialog from '@/components/dialog';
  import SelectTree from "../parallelBranch/selectTree";

  export default {
    props: {
      id: {
        type: [String, Number]
      },
      projectId: {
        type: [String, Number]
      },
      isType: {
        type: [String, Number]
      },
      selectedDeviceFormInfo: {
        type: [Object, Number]
      }
    },
    data() {
      return {
        loading: false,
        deviceBindInfo: {
          projectId: '',
          projectName: '',
          equipType: -1,
          equipTypeName: "",
          equipQuantity: 0,
          templateEquip: '',
          templateEquipDesc: '',
          equipFits: [],
          equipFitBinds: [],
          gridId: ""
        },

        deviceTypeOptions: [], // 设备类型列表
        deviceTreeData: [], // 设备列表树

        templateDeviceTree: [], // 模版设备树
        templateTreeProps: {
          children: 'children',
          label(data) {
            return data.equipDesc + " (" + data.equipName + ")"
          }
        },

        treeDataConfig: [], // 数据点配置-(左侧)数据组树
        defaultProps: {
          children: 'childrenList',
          label: 'field'
        },
        checkedId: '', // 数据组配置-(左侧)数据组树-一级节点id
        defaultChecked: [], // 数据组配置-数据组树-默认勾选的节点的 key 的数组

        pointTableData: [], // 数据点配置-数据点列表
        pointSelectionId: "", // 数据点配置-数据点列表-当前选择数据点-行id

        rules: {
          templateEquipDesc: [{
            required: true,
            message: '请选择模版设备',
            trigger: 'blur'
          }],
          gridId: [{
            required: true,
            message: '请选择并网点',
            trigger: 'blur'
          }]
        },

        currentConfigParamId: 0, // 当前被配置的典型参数，即参数绑定列表中被点击的行对应的典型参数id
        preEquipFitBinds: [], // 待配置（保存）的典型参数-数据点绑定信息组[{},{}]
        bindedParamIds: [], // 从详细信息获取的已绑定的典型参数

        errorInfo: {}, // 配置生效错误的提示信息
        gridOptions: [], //并网点列表
      };
    },
    components: {
      Dialog,
      SelectTree
    },
    created() {
      this.searchProjectGridList()
    },
    mounted() {
      this.init()
    },
    watch: {},
    computed: {},
    methods: {
      //初始化
      init() {
        if (this.isType !== 'add') {
          this.getEquipConfigDetail(); // 查询设备配置详情
        }

        // 用 step1-设备配置 中表单数据更新本页面                 // 配置、新增进入该页面，项目、设备选择信息一定已存在
        if (this.isType !== 'detail') {
          this.deviceBindInfo.projectId = this.selectedDeviceFormInfo.projectId;
          this.deviceBindInfo.projectName = this.selectedDeviceFormInfo.projectName;
          this.deviceBindInfo.equipType = this.selectedDeviceFormInfo.equipType;
          this.deviceBindInfo.equipTypeName = this.selectedDeviceFormInfo.equipTypeName;
          this.deviceBindInfo.equipFitIds = this.selectedDeviceFormInfo.equipFitIds;
          this.deviceBindInfo.gridId = this.selectedDeviceFormInfo.gridId;

          this.equipCheckTreeList(); // 获取设备树->生成适配设备列表、设备数量、模版设备
          this.getEquipTypicalParamListByEquipType(); // 获取典型参数
        }
      },

      //获取并网点列表
      searchProjectGridList() {
        let params = {
          projectId: this.selectedDeviceFormInfo.projectId,
          pageNum: 1,
          pageSize: 100
        }
        EQUIPMENTCONFIGAPI.searchProjectGridList(params).then(res => {
          if (res.data.code == 200) {
            this.gridOptions = res.data.data.dataList
            this.gridOptions.map(item => {
              item.id = item.id + ''
              return item
            })
          }
        })
      },
      // 查询设备配置详情
      getEquipConfigDetail() {
        let params = {
          projectId: this.projectId,
        };
        if (this.id && this.id > 0) {
          params.infoId = this.id
        }
        EQUIPMENTCONFIGAPI.getEquipConfigDetail(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {

            // 项目、设备选择信息
            if (this.isType === 'detail') { // 如果是点击配置进入该页面，这部分信息可能在前一页（设备选择页）有更新，因此以前一页为准
              this.deviceBindInfo.projectId = res.data.data.projectId;
              this.deviceBindInfo.projectName = res.data.data.projectName;
              this.deviceBindInfo.equipType = res.data.data.equipType;
              this.deviceBindInfo.equipTypeName = res.data.data.equipTypeName;
              this.deviceBindInfo.equipFits = res.data.data.equipFits;
              this.deviceBindInfo.equipQuantity = res.data.data.equipQuantity;
            }
            this.deviceBindInfo.gridId = res.data.data.gridId + '';
            // 参数绑定信息
            this.deviceBindInfo.templateEquip = res.data.data.templateEquip;
            res.data.data.equipFits.forEach(item => {
              if (item.equipId === this.deviceBindInfo.templateEquip) {
                this.deviceBindInfo.templateEquipDesc = item.equipDesc + ' (' + item.equipFields + ')';
              }
            });
            this.deviceBindInfo.equipFitBinds = res.data.data.equipFitBinds;

            this.bindedParamIds = this.deviceBindInfo.equipFitBinds.map(item => item.equipTyPaId);
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      // 获取设备树
      equipCheckTreeList() {
        this.loading = true;
        let params = {
          projectId: this.deviceBindInfo.projectId,
        };
        if (this.id && this.id > 0) {
          params.infoId = this.id
        }
        EQUIPMENTCONFIGAPI.equipCheckTreeList(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.deviceTreeData = this.formatTreeData(res.data.data);
            if (this.deviceTreeData) {
              this
                .generateLeftTableData(); // 生成适配设备列表、设备数量，params: deviceTreeData、selectedDeviceFormInfo.equipFitIds
            }
            const originTree = this.deviceTreeData;
            const params = this.selectedDeviceFormInfo.equipFitIds.map(item => String(item));
            this.generateTemplateDeviceTree(originTree, params); // 生成模版设备树
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
        this.loading = false;
      },

      // 获取典型参数(新增、配置场景使用)
      getEquipTypicalParamListByEquipType() {
        let params = {
          equipType: this.deviceBindInfo.equipType,
        };
        TYPICALPARAMAPI.getEquipTypicalParamListByEquipType(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            if (res.data.data) {
              res.data.data.forEach((item) => {
                const tempColumn = {
                  equipTyPaId: item.id ? item.id : '',
                  equipTyPaName: item.tyDPName ? item.tyDPName : '',
                  equipTyPaDesc: item.tyDPDesc ? item.tyDPDesc : '',
                };

                if (!this.bindedParamIds.includes(item.id)) { // 已绑定参数(来源与设备配置详情信息)与该设备典型参数列表合并
                  this.deviceBindInfo.equipFitBinds.push(tempColumn)
                }

                if (this.isType === 'edit') {
                  this.deviceBindInfo.equipFitBinds.sort((a, b) => a.id - b.id);
                }
              });
            }
            this.$nextTick(function() {
              this.$refs.typicalParamTable.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      // ----------------------------------------------------------------------------------------------- 数据点弹窗操作
      // 数据点配置
      setDevicePoints(row) {
        this.currentConfigParamId = row.equipTyPaId;
        this.$refs.deviceBindForm.validate(valid => {
          if (valid) {
            this.searchFieldTreeByProjectAndEquipId();
            this.$refs.dataPointConfigDlg.open();
          }
        })
      },

      // 查询项目下点表树-选定设备
      searchFieldTreeByProjectAndEquipId() {
        let params = {};
        params.projectId = this.deviceBindInfo.projectId;
        params.equipId = isNaN(this.deviceBindInfo.templateEquipDesc) ? this.deviceBindInfo.templateEquip : this
          .deviceBindInfo.templateEquipDesc; // 模版设备id
        EQUIPMENTCONFIGAPI.searchFieldTreeByProjectAndEquipId(params).then(res => {
          if (res.data.code === 200) {
            this.treeDataConfig = res.data.data.fieldTreeVoList;
          }
        })
      },

      // 点击数据点配置弹窗左边数据组
      handleNodeClick(row) {
        this.loading = true;
        this.pointSelectionId = '';
        this.searchFieldByTree(row);
      },

      // 查询数据组下数据点-数据点配置弹窗右侧列表
      searchFieldByTree(data) {
        let params = {
          emsId: data.emsId,
          field: data.currentFullField,
          projectId: this.deviceBindInfo.projectId,
          authorizations: "0, 1, 2"
        };
        PROJECTAPI.searchFieldByTree(params).then(res => {
          if (res.data.code === 200) {
            this.pointTableData = res.data.data;
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        });
      },

      // 数据点配置-数据点列表-单击该行
      singleElection(row) {
        this.pointSelectionId = row.fieldId;
      },

      // ----------------------------------------------------------------------------------------------- 弹窗按钮操作
      // 保存（弹窗）-存储该标准点的数据点绑定信息
      onSave() {
        const selectedBindInfo = {
          equipTyPaId: this.currentConfigParamId,
          pointSelectionId: this.pointSelectionId
        };

        let isFind = false;

        // 一个参数智能绑定一个数据点，因此用新值替换旧值
        this.preEquipFitBinds.forEach(item => {
          if (item.equipTyPaId === selectedBindInfo.equipTyPaId) {
            item.selectedBindInfo = selectedBindInfo.pointSelectionId;
            isFind = true;
          }
        });

        if (!isFind) {
          this.preEquipFitBinds.push(selectedBindInfo);
        }

        // 获取绑点描述信息,表格最后一列显示内容
        let field = '';
        let fieldDesc = '';
        this.pointTableData.forEach(item => {
          if (item.fieldId === selectedBindInfo.pointSelectionId) {
            field = item.field;
            fieldDesc = item.fieldDesc;
          }
        });
        // 更新参数绑定表格
        this.deviceBindInfo.equipFitBinds.map(item => {
          if (item.equipTyPaId === selectedBindInfo.equipTyPaId) {
            item.fieldsId = selectedBindInfo.pointSelectionId;
            item.fieldsAndDesc = field + ';' + fieldDesc;
          }
        });

        this.$nextTick(function() {
          this.$refs.typicalParamTable.doLayout();
        });

        this.$refs.dataPointConfigDlg.close();
      },

      // 取消（弹窗）-对话框关闭
      close() {
        this.$refs.dataPointConfigDlg.close();
      },

      // ----------------------------------------------------------------------------------------------- 页面按钮操作
      //自动匹配
      async autoMatchDataPoints() {
        let params = {
          equipTyPaIds:[],
          templateEquip: isNaN(this.deviceBindInfo.templateEquipDesc) ? Number(this.deviceBindInfo.templateEquip) :
            Number(this.deviceBindInfo.templateEquipDesc),
        };
        if(params.equipTyPaIds.length>0){
          this.$message.error('未获取到绑定参数')
          return false
        }
        if(!params.templateEquip){
          this.$message.error('未查询到绑定设备')
          return false
        }
        // 保存绑定信息参数需要包含已有绑定信息
        this.deviceBindInfo.equipFitBinds.forEach(item => {
            params.equipTyPaIds.push(item.equipTyPaId)
        })
        let res = await EQUIPMENTCONFIGAPI.autoMatchDataPoints(params)
        if(res.data.code ==200){
          let d = res.data.data
          if(d.length>0){
            this.$nextTick(()=>{
              this.deviceBindInfo.equipFitBinds.map(item=>{
                for(let i=0;i<d.length;i++){
                  if(d[i].equipTyPaId==item.equipTyPaId){
                    item.fieldsAndDesc = d[i].fieldsDesc
                    item.fieldsId = d[i].fieldsId
                    break
                  }
                  }
                return item
              })
                this.$refs.typicalParamTable.doLayout();
            })
          }
          console.log(this.deviceBindInfo)
        }
      },
      // 保存-提交参数绑定信息
      onSaveBindBaseInfo() {
        let params = {
          projectId: this.deviceBindInfo.projectId,
          equipType: this.deviceBindInfo.equipType,
          gridId: this.deviceBindInfo.gridId,
          equipFitIds: this.deviceBindInfo.equipFits.map(item => Number(item.equipId)),
          templateEquip: isNaN(this.deviceBindInfo.templateEquipDesc) ? Number(this.deviceBindInfo.templateEquip) :
            Number(this.deviceBindInfo.templateEquipDesc),
        };

        if (this.id && this.id > 0) {
          params.infoId = this.id
        }

        // 保存绑定信息参数需要包含已有绑定信息
        params.equipFitBinds = this.deviceBindInfo.equipFitBinds.map(item => {
          return {
            equipTyPaId: item.equipTyPaId,
            fieldsId: item.fieldsId
          }
        }).filter(it => (it.fieldsId !== undefined && it.fieldsId !== ""));

        EQUIPMENTCONFIGAPI.saveEquipConfig(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功');
            this.$refs.dataPointConfigDlg.close();
            this.$emit('save', res.data.data)
          }
        });
      },

      // 配置生效-生效项目并网点绑定设备
      takeEffectEquipConfig() {
        EQUIPMENTCONFIGAPI.takeEffectEquipConfig({
          infoId: this.id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
          } else {
            this.errorInfo = res.data.data;
            this.$refs.saveErrorDlg.open();
          }
        })
      },

      // 取消-跳转到列表
      cancel() {
        this.preEquipFitBinds = [];
        this.$emit('closeBind')
      },

      closeErrorDlg() {
        this.$refs.saveErrorDlg.close();
      },

      // 以下是3个数据转换工具
      // 配置、新增进入，则根据step1-选择设备表单内容生成表格信息
      generateLeftTableData() {
        let equipFits = [];
        this.deviceTreeData.forEach((i) => {
          if (i.children && i.children.length > 0) {
            const temp = {
              emsDesc: '',
              emsName: '',
              equipFields: '',
              equipDesc: '',
            };
            temp.emsDesc = i.equipDesc;
            temp.emsName = i.equipName;
            i.children.forEach((j) => {
              if (j.children.length > 0) {
                j.children.forEach((k) => {
                  if (this.selectedDeviceFormInfo.equipFitIds.includes(Number(k.equipId))) {
                    const newTemp = {
                      ...temp
                    };
                    newTemp.equipFields = k.equipName;
                    newTemp.equipDesc = k.equipDesc;
                    newTemp.equipId = k.equipId;
                    equipFits.push(newTemp);
                  }
                })
              }
            })
          }
        });
        this.deviceBindInfo.equipFits = equipFits;
        this.deviceBindInfo.equipQuantity = this.deviceBindInfo.equipFits.length;
        this.$nextTick(function() {
          this.$refs.adaptedDeviceTable.doLayout();
        });
      },

      // 生成模版设备列表   originTree 原始树结构数据, param 子节点id-筛选参数
      generateTemplateDeviceTree(originTree, params) {
        // 树转数组
        const newData = [];
        const res = originTree.reduce(function fn(prev, curr) {
          prev.push({
            equipDesc: curr.equipDesc,
            equipId: curr.equipId,
            equipName: curr.equipName,
            parentId: curr.parentId,
          });

          curr.children && curr.children.forEach(v => {
            v.parentId = curr.equipId;
            fn(prev, v);
          });

          return prev;
        }, []);

        // 将2级、1级节点id都包含进来
        for (let i = 0; i < 2; i++) {
          res.forEach((item) => {
            if (params.includes(item.equipId)) {
              params.push(item.parentId);
            }
          });
        }

        // newData 为包含模版设备树的数组（列表）形式
        res.forEach((item) => {
          if (params.includes(item.equipId)) {
            newData.push(item);
          }
        });

        // 数组转树
        this.templateDeviceTree = newData.reduce(function(prev, curr, i, arr) {
          curr.children = arr.filter(v => v.parentId === curr.equipId);
          if (!curr.parentId) {
            prev.push(curr)
          }

          return prev;
        }, []);

      },

      // 设备列表只展示到三级
      formatTreeData(deviceList) {
        if (deviceList && deviceList.length > 0) {
          for (const L1Data of deviceList) {
            if (L1Data.childList && L1Data.childList.length > 0) {
              for (const L2Data of L1Data.childList) {
                if (L2Data.childList && L2Data.childList.length > 0) {
                  for (const L3Data of L2Data.childList) {
                    if (L3Data.childList && L3Data.childList.length > 0) {
                      L3Data.childList = [];
                    }
                  }
                }
              }
            }
          }
        }
        return deviceList;
      }

    }
  };
</script>

<style lang="scss">
  .deviceBind {
    .device-bind-dlg {
      .el-select {
        width: 100% !important;
      }

      .search-div {
        margin: 10px 0px;
      }

      .config-div {
        display: flex;

        .tree-wrap {
          width: 180px;
          height: 50vh;
          border: 1px solid #dcdfe6;
          border-radius: 5px;

          .el-tree {
            margin-top: 10px;
          }
        }

        .points-wrap {
          width: calc(100% - 200px);
          margin-left: 20px;
          border: 1px solid #dcdfe6;
        }
      }

      .el-dialog__wrapper {
        .el-dialog {
          width: 40% !important;

          .el-dialog__footer {
            padding: 0px !important;
          }
        }
      }
    }

    .save-error-dlg {
      .el-dialog__wrapper {
        .el-dialog {
          width: 60% !important;

          .el-dialog__footer {
            padding: 0px !important;
          }
        }
      }
    }

    .el-card__body {
      padding: 0.0rem;
    }

    .tools {
      text-align: center;
      margin-top: 15px;
    }

    .btn-tools {
      text-align: center;
      margin-top: 35px;

      .btn {
        width: 100px;
      }
    }

    .device-points {
      color: #0261e4;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/deviceConfiguration/deviceBind.vue